import React from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IFormHeadingProps } from './types';
import styles from './FormHeading.module.css';

export const FormHeading: React.FC<IFormHeadingProps> = ({
  title,
  subTitle,
  showBackButton,
  backPath,
}) => {
  const history = useHistory();

  const handleClickBack = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();

    if (backPath) {
      history.replace(backPath);
    } else if (showBackButton) {
      history.goBack();
    }
  };

  return (
    <div className={styles.container} onClick={handleClickBack}>
      {(showBackButton || backPath) && (
        <div className={styles.icon}>
          <FontAwesomeIcon icon={['far', 'arrow-left']} />
        </div>
      )}
      <div>
        <span className={styles.title}>{title}</span>
        {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
      </div>
    </div>
  );
};
